module.exports = __webpack_public_path__ + "school/img/fuwuqi.5c4c691b.jpg";